import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form,Tooltip, Button, Spinner, Alert, Card } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { newSubProductCreation,getAllMainSubProduct } from "./subproductAction";
import { newAdultRatesCreation,newChildRatesCreation,newInfantRatesCreation,newSeasonalRatesCreation ,newPromotionRatesCreation,getSingleProductRate,childrateDeletion,adultrateModification,
  childrateModification,infantrateModification,infantrateDeletion,seasonalrateModification,promotionrateModification, seasonalrateDeletion,promotionrateDeletion,hourrateModification,vehiclerateModification} from "../rates/ratesAction";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight, faRightToBracket, faUpload, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import Datetime from "react-datetime";
import { DefaultEditor } from 'react-simple-wysiwyg';
import { upload } from '@testing-library/user-event/dist/upload';
import UploadService from "../../../api/FileUploadApi";
import { useNavigate,useParams } from 'react-router-dom';
import Swal from 'sweetalert2'
import { getAllProduct } from "../product/productAction";
import { FaEye, FaArrowLeft,FaArrowAltCircleRight, FaTrash, FaPlus, FaBan} from 'react-icons/fa';
// import { Tooltip } from 'react-tooltip';
import { getSinglePaxhealth } from "../paxhealth/paxhealthAction";


const ModifyRates = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { baseId } = useParams();
  console.log("baseId",baseId)
  const { pid1 } = useParams();
  const { pid2 } = useParams();
  const { pname1 } = useParams();
  const { pname2 } = useParams();
  const SubProductRef = useRef(null);
  const [productid,setProductid]= useState('');
  const [subproductname,setSubproductname]= useState('');
  const [isAlive, setIsAlive] = useState('');
  const [perShow,setPerShow] = useState(false);
  const[disbutton1, setDisbutton1] = useState(true)
  const[disbutton2, setDisbutton2] = useState(true)
  const[disbutton3, setDisbutton3] = useState(true)
  const[disbutton4, setDisbutton4] = useState(true)
  const [fixamtShow,setFixamtShow] = useState(false);
  const [permdata , setPermdata] = useState();
  const paxData = useSelector((state) => state.paxList);
  const pxData = JSON.parse(JSON.stringify(paxData.pSDetails));

  const { subproducts2 } = useSelector((state) => state.subproductList);


  const [percentage,setPercentage]= useState('');
  const [fixamt,setFixamt]= useState('');
  const [paxlimit,setPaxlimit]= useState('');
  const [paxlimitno,setPaxlimitNo]= useState('');

  const [status,setStatus]= useState('');
  const [sfromDate , setSFromDate ] = useState('');
  const [toDate2 , setToDate2 ] = useState('');
  const [discounttype , setDiscounttype ] = useState('');
  const [discounttype2 , setDiscounttype2 ] = useState('');
  const [discount2 , setDiscount2 ] = useState('');
  const [discount , setDiscount ] = useState('');
  const [seasonalremark , setSeasonalremark ] = useState('');
  const [promotionremark , setPromotionremark ] = useState('');
  const [offercode , setOffercode ] = useState('');
  const [toDate3 , setToDate3 ] = useState('');
  const [fromDate , setFromDate ] = useState('');
  const [toDate , setToDate ] = useState('');
  const [fromDate2 , setFromDate2 ] = useState('');
  const [fromAge2, setFromAge2] = useState('');
  const [fromAge, setFromAge] = useState('');
  const [toAge, setToAge] = useState('');
  const [toAge2, setToAge2] = useState('');
  const [errors2, setErrors2] = useState({});
  const [hourrate, setHourrate] = useState([]);
  const [vehiclerate, setVehiclerate] = useState([]);

  const [tabHandle, setTabHandle] = useState('adultrate');
  const [tabHandle2, setTabHandle2] = useState('rate');
  const [errors3, setErrors3] = useState({});
  const [fromAgeError, setFromAgeError] = useState('');
  const [toAgeError, setToAgeError] = useState('');

  const [fromDateError, setFromDateError] = useState('');
  const [fromDateError2, setFromDateError2] = useState('');
  const [toDateError, setToDateError] = useState('');
  const [toDateError2, setToDateError2] = useState('');
  const [paxlimitshow, setPaxlimitShow] = useState(false);


  const [fromAgeError2, setFromAgeError2] = useState('');
  const [toAgeError2, setToAgeError2] = useState('');

  const [alertStatus, setAlertStatus] = useState('');
  const { register, handleSubmit, watch,formState: { errors } } = useForm();
  const { products } = useSelector((state) => state.productList);
  const { baseid, dmessage, mmessage,imessage,smessage,pmessage,hpmessage, vpmessage } = useSelector((state) => state.productratesList);

  const ratesvehicle  = useSelector((state) => state.productratesList?.rates?.vehicle || []);
  const rateshour  = useSelector((state) => state.productratesList?.rates?.hour || []);
  const rates  = useSelector((state) => state.productratesList?.rates?.adult || []);
  const rates2 = useSelector((state) => state.productratesList?.rates?.child || []);
  const rates3 = useSelector((state) => state.productratesList?.rates?.infant || {});
  const rates4 = useSelector((state) => state.productratesList?.rates?.supplement || {});
  const rates5 = useSelector((state) => state.productratesList?.rates?.promotion || {});
//   const { SubProductId } = useSelector((state) => state.subproductList);
console.log("rateshour",rateshour)
  const { supiscLoading, supcstatus, supcMessage, } = useSelector((state) => state.supplierList);
  const [sections, setSections] = useState([]);
  const [removerate, setRemoverate] = useState([]);
  // const [sections, setSections] = useState([...rates2]);
  const [sections2, setSections2] = useState([]);
  const [resetRates2, setResetRates2] = useState(false);
  const [sections3, setSections3] = useState([]);
  const [sections4, setSections4] = useState([]);
  const [adultrate, setAdultrate] = useState([]);
  const [adultratecopy, setAdultratecopy] = useState([]);
  const [hourratecopy, setHourratecopy] = useState([]);
  const [vehicleratecopy, setVehicleratecopy] = useState([]);
  const [extraAdultrate, setExtraAdultrate] = useState([]);
  const [childrate, setChildrate] = useState([]);
  const [childratecopy, setChildratecopy] = useState([]);
  const [infantrate, setInfantrate] = useState([]);
  const [seasonal, setSeasonal] = useState([]);
  const [promotion, setPromotion] = useState([]);
  const [isToDateSelected, setIsToDateSelected] = useState(false);

  console.log("promotion",promotion)
  console.log("seasonal",seasonal)
  console.log("infantrate",infantrate)
  console.log("chidratedata",childrate)
  console.log("adultrate",adultrate)
  const handleAddSection = () => {
    setDisbutton1(false);
    setSections(prevSections => [...prevSections, { childrate: Array(7).fill('') }]);
  };
  
  
  const handleAddSection2 = () => {
    setDisbutton2(false);
    setSections2(prevSections => [...prevSections, { infantrate: Array(7).fill('') }]);
  };


  const handleAddSection3 = () => {
    setDisbutton3(false);
    setSections3(prevSections => [...prevSections, { seasonal: Array(7).fill('') }]);
  };

  const handleAddSection4 = () => {
    setDisbutton4(false)
    setSections4(prevSections => [...prevSections, { promotion: Array(7).fill('') }]);
  };

  // const handleRemoveSection = (index, idd) => {
  //   setDisbutton1(true);
  
  //   if (index < rates2.length) {
  //     // If the section is from the database, delete it directly from the database
  //     const sectionToRemove = rates2[index];
  
  //     // Call the appropriate delete function or API endpoint to delete the section from the database
  //     Swal.fire({
  //       // ... your Swal configuration ...
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         dispatch(childrateDeletion(idd)).then(() => {
  //           // Remove the section from rates2 array
  //           const updatedRates = rates2.filter((section) => section.id !== idd);
  //           console.log('Updated rates2:', updatedRates);
  //           setRemoverate(updatedRates);

  //           const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

  
  //           // Map the updatedRates array to updatedSections
  //           const updatedSections = updatedRates.map((section) => ({
  //             id: section.id,
  //             fromAge: section.from_age,
  //             toAge: section.to_age,
  //             childrate: daysOfWeek.map((day) => (section[day] || '').toString()),
  //           }));
  
  //           console.log('Updated sections:', updatedSections);
  
  //           // Update the state with the updatedSections
  //           setSections(updatedSections);
  
  //           // Remove the child rate from the childrate state
  //           setChildrate((prevChildrate) => {
  //             const updatedChildrate = [...prevChildrate];
  //             updatedChildrate.splice(index, 1);
  //             return updatedChildrate;
  //           });
  
  //           Swal.fire('Child Rate Deleted Successfully!', '', 'success');
            
  //         });
  //       } else if (result.isDenied) {
  //         Swal.fire('Changes are not saved', 'Your Data is safe', 'info');
  //       }
  //     });
  //   } else {
  //     // If the section is not from the database, remove it from the state
  //     setSections((prevSections) => prevSections.filter((_, i) => i !== index));
  
  //     // Remove the child rate from the childrate state
  //     setChildrate((prevChildrate) => {
  //       const updatedChildrate = [...prevChildrate];
  //       updatedChildrate.splice(index, 1);
  //       return updatedChildrate;
  //     });
  //   }
  // };

  const handleRemoveSection = (index, idd) => {
    
    setDisbutton1(true);
    console.log(idd);
    if (index < rates2.length) {
      // If the section is from the database, delete it directly from the database
      const sectionToRemove = rates2[index];
      // Call the appropriate delete function or API endpoint to delete the section from the database
      Swal.fire({
        title: 'Are you sure want to delete this Child Rate?',
        showDenyButton: true,
        icon: 'error',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        denyButtonText: 'No',
        customClass: {
          actions: 'my-actions',
          cancelButton: 'order-1 right-gap',
          confirmButton: 'order-2',
          denyButton: 'order-3',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(childrateDeletion(idd)).then(() => {
            dispatch(getSingleProductRate(baseId));
            setSections((prevSections) => prevSections.filter((_, i) => i !== index));

           
            Swal.fire('Child Rate Deleted Successfully!', '', 'success');
          });
        } else if (result.isDenied) {
          Swal.fire('Changes are not saved', 'Your Data is safe', 'info');
        }
      });
  
      // After successful deletion, update the state by removing the section from the sections array
  
      // Remove the child rate from the childrate state
      setChildrate((prevChildrate) => {
        const updatedChildrate = [...prevChildrate];
        updatedChildrate.splice(index, 1);
        return updatedChildrate;
      });
    } else {
      // If the section is not from the database, remove it from the state
      setSections((prevSections) => prevSections.filter((_, i) => i !== index));
  
      // Remove the child rate from the childrate state
      setChildrate((prevChildrate) => {
        const updatedChildrate = [...prevChildrate];
        updatedChildrate.splice(index, 1);
        return updatedChildrate;
      });
    }
  };
  
  
  
  console.log("ratessss2",rates2)
  console.log("sections.length",sections.length)
  
  




  const handleRemoveSection2 = (index, idd) => {
    console.log(idd);
    setDisbutton2(true);
    if (index < rates3.length) {
      // If the section is from the database, delete it directly from the database
      const sectionToRemove = rates3[index];
      // Call the appropriate delete function or API endpoint to delete the section from the database
      Swal.fire({
        title: 'Are you sure want to delete this Infant Rate?',
        showDenyButton: true,
        icon: 'error',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        denyButtonText: 'No',
        customClass: {
          actions: 'my-actions',
          cancelButton: 'order-1 right-gap',
          confirmButton: 'order-2',
          denyButton: 'order-3',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(infantrateDeletion(idd)).then(() => {
            dispatch(getSingleProductRate(baseId));
            setSections2((prevSections) => prevSections.filter((_, i) => i !== index));

           
            Swal.fire('Infant Rate Deleted Successfully!', '', 'success');
          });
        } else if (result.isDenied) {
          Swal.fire('Changes are not saved', 'Your Data is safe', 'info');
        }
      });
  
      // After successful deletion, update the state by removing the section from the sections array
  
      // Remove the infant rate from the infantrate state
      setInfantrate((prevInfantrate) => {
        const updatedInfantrate = [...prevInfantrate];
        updatedInfantrate.splice(index, 1);
        return updatedInfantrate;
      });
    } else {
      // If the section is not from the database, remove it from the state
      setSections2((prevSections) => prevSections.filter((_, i) => i !== index));
  
      // Remove the child rate from the childrate state
      setInfantrate((prevInfantrate) => {
        const updatedInfantrate = [...prevInfantrate];
        updatedInfantrate.splice(index, 1);
        return updatedInfantrate;
      });
    }
  };
  




  const handleRemoveSection3 = (index, idd) => {
    setDisbutton3(true)
    console.log(idd);
    if (index < rates4.length) {
      // If the section is from the database, delete it directly from the database
      const sectionToRemove = rates4[index];
      // Call the appropriate delete function or API endpoint to delete the section from the database
      Swal.fire({
        title: 'Are you sure want to delete this Seasonal Rate?',
        showDenyButton: true,
        icon: 'error',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        denyButtonText: 'No',
        customClass: {
          actions: 'my-actions',
          cancelButton: 'order-1 right-gap',
          confirmButton: 'order-2',
          denyButton: 'order-3',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(seasonalrateDeletion(idd)).then(() => {
            dispatch(getSingleProductRate(baseId));
            setSections3((prevSections) => prevSections.filter((_, i) => i !== index));

           
            Swal.fire('Seasonal Rate Deleted Successfully!', '', 'success');
          });
        } else if (result.isDenied) {
          Swal.fire('Changes are not saved', 'Your Data is safe', 'info');
        }
      });
  
      // After successful deletion, update the state by removing the section from the sections array
  
      // Remove the infant rate from the infantrate state
      setSeasonal((prevSeasonalrate) => {
        const updatedSeasonalrate = [...prevSeasonalrate];
        updatedSeasonalrate.splice(index, 1);
        return updatedSeasonalrate;
      });
    } else {
      // If the section is not from the database, remove it from the state
      setSections3((prevSections) => prevSections.filter((_, i) => i !== index));
  
      // Remove the child rate from the childrate state
      setSeasonal((prevSeasonalrate) => {
        const updatedSeasonalrate = [...prevSeasonalrate];
        updatedSeasonalrate.splice(index, 1);
        return updatedSeasonalrate;
      });
    }
  };




  const handleRemoveSection4 = (index, idd) => {
    setDisbutton4(true);
    console.log(idd);
    if (index < rates5.length) {
      // If the section is from the database, delete it directly from the database
      const sectionToRemove = rates5[index];
      // Call the appropriate delete function or API endpoint to delete the section from the database
      Swal.fire({
        title: 'Are you sure want to delete this Promotion Rate?',
        showDenyButton: true,
        icon: 'error',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        denyButtonText: 'No',
        customClass: {
          actions: 'my-actions',
          cancelButton: 'order-1 right-gap',
          confirmButton: 'order-2',
          denyButton: 'order-3',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(promotionrateDeletion(idd)).then(() => {
            dispatch(getSingleProductRate(baseId));
            setSections4((prevSections) => prevSections.filter((_, i) => i !== index));

           
            Swal.fire('Promotion Rate Deleted Successfully!', '', 'success');
          });
        } else if (result.isDenied) {
          Swal.fire('Changes are not saved', 'Your Data is safe', 'info');
        }
      });
  
      // After successful deletion, update the state by removing the section from the sections array
  
      // Remove the infant rate from the infantrate state
      setPromotion((prevPromotionrate) => {
        const updatedPromotionrate = [...prevPromotionrate];
        updatedPromotionrate.splice(index, 1);
        return updatedPromotionrate;
      });
    } else {
      // If the section is not from the database, remove it from the state
      setSections4((prevSections) => prevSections.filter((_, i) => i !== index));
  
      // Remove the child rate from the childrate state
      setPromotion((prevPromotionrate) => {
        const updatedPromotionrate = [...prevPromotionrate];
        updatedPromotionrate.splice(index, 1);
        return updatedPromotionrate;
      });
    }
  };



  const handleCopyToAll2 = (sectionIndex, index) => {
    const selectedValue = sections[sectionIndex]?.childrate[index];
  const updatedRates = sections[sectionIndex]?.childrate.map(() => selectedValue);

  const updatedSections = [...sections];
  updatedSections[sectionIndex].childrate = updatedRates;
  setSections(updatedSections);
  };


  const handleCopyToAll3 = (sectionIndex, index) => {
    const selectedValue = sections2[sectionIndex]?.infantrate[index];
  const updatedRates = sections2[sectionIndex]?.infantrate.map(() => selectedValue);

  const updatedSections = [...sections2];
  updatedSections[sectionIndex].infantrate = updatedRates;
  setSections2(updatedSections);
  };

  const handleChildRateChange = (sectionIndex, index, value) => {
    // console.log("sectionIndex",sectionIndex)
    // console.log("index",index)
    // console.log("value",value)
    setDisbutton1(false);
    const updatedSections = [...sections];
    updatedSections[sectionIndex].childrate[index] = value;
    // console.log("updatedSections",updatedSections)
    setSections(updatedSections);
    // const currentSection = updatedSections[sectionIndex];
    // const currentChildRateData = [currentSection]; 
    const currentChildRateData1 = updatedSections.filter(childrateValue => !childrateValue.hasOwnProperty('id'));
    // console.log("currentChildRateDatacurrentChildRateData",currentChildRateData1)
    setChildrate(currentChildRateData1)
  };


  const handleInfantRateChange = (sectionIndex, index, value) => {
    setDisbutton2(false)
    const updatedSections = [...sections2];
    updatedSections[sectionIndex].infantrate[index] = value;
    setSections2(updatedSections);
    const currentInfantRateData1 = updatedSections.filter(infantrateValue => !infantrateValue.hasOwnProperty('id'));

    setInfantrate(currentInfantRateData1)
  };
  const handleAdultRateChange = (index, value) => {
    const updatedAdultrate = [...adultrate];
    updatedAdultrate[index] = value;
    setAdultrate(updatedAdultrate);
  };

  const handleExtraAdultRateChange = (index, value) => {
    const updatedAdultrate = [...extraAdultrate];
    updatedAdultrate[index] = value;
    setExtraAdultrate(updatedAdultrate);
  };


  useEffect(() => {
    const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    if (rates2[0]?.base_product_id === Number(baseId) && rates2.length > 0) {
      const updatedSections = rates2.map((section) => ({
        id: section.id,
        fromAge: section.from_age,
        toAge: section.to_age,
        childrate: daysOfWeek.map((day) => (section[day] || '').toString()),
      }));
  
      setSections(updatedSections);
      setChildrate(updatedSections);
      setChildratecopy(updatedSections);
   
    }
  }, [rates2]);
console.log("ratttttts2",rates2)
console.log("childrarrrar",childrate)
console.log("secccc",sections)
console.log("mmessage",mmessage)

  useEffect(() => {
    const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

    if (rates3[0]?.base_product_id === Number(baseId) && rates3.length > 0) {
      const updatedSections = rates3.map((section) => ({
        id: section.id,
        fromAge2: section.from_age,
        toAge2: section.to_age,
        infantrate: daysOfWeek.map((day) => (section[day] || '').toString()),
      }));
  
      setSections2(updatedSections);
      setInfantrate(updatedSections);
    }
  }, [rates3]);
  





  
  useEffect(() => {
    const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

    if (rates4[0]?.base_product_id === Number(baseId) && rates4.length > 0) {
      const updatedSections33 = rates4.map((section) => ({
        id: section.id,
        fromDate2: section.start_date,
        toDate2: section.end_date,
        discounttype: section.discount_type,
        discount: section.discount,
        seasonalremark: section.remarks,
      }));
  
      setSections3(updatedSections33);
      setSeasonal(updatedSections33);
    }
  }, [rates4]);




    
  useEffect(() => {
    const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

    if (rates5[0]?.base_product_id === Number(baseId) && rates5.length > 0) {
      const updatedSections33 = rates5.map((section) => ({
        id: section.id,
        fromDate3: section.start_date,
        toDate3: section.end_date,
        discounttype2: section.discount_type,
        discount2: section.discount,
        offercode: section.offer_code,
        promotionremark: section.remarks,
      }));
  
      setSections4(updatedSections33);
      setPromotion(updatedSections33);
    }
  }, [rates5]);
  



  

  
  

//   const renderCommissionFields = () => {
//     const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
//     if (!Array.isArray(rates)) {
//         return null; // Return null or any other fallback JSX if rates2 is not an array
//       }
//       const handleCopyToAll = () => {
//         const firstValue = adultrate[0]; // Get the value of the first field
      
//         // Copy the first value to all other fields
//         const updatedRates = daysOfWeek.map(() => firstValue);
      
//         setAdultrate(updatedRates); // Update the state with the new values
//       };
      
//       return rates.map((section, sectionIndex) => (
//         <div>
//         <div style={{ display: 'flex',marginTop:'30px'  }}>
//         <Row className="mb-3" style={{padding:'10px'}}>
//       <Form.Group as={Col} controlId="formGridServiceType">
//         <Form.Label>From Date <span className='text-danger'>*</span></Form.Label>
//         <Form.Control
//           type="date"
//           name="fromDate"
//           required
           
//           value={fromDate ? fromDate :section?.from_date}
//           {...register('fromDate', { required: true })}
//           onChange={(e) => setFromDate(e.target.value)}

//           autoComplete="off"
//           placeholder="Enter From Date"
    
//         />
//       </Form.Group>

//       <Form.Group as={Col} controlId="formGridMobile">
//         <Form.Label>To Date<span className='text-danger'>*</span></Form.Label>
//         <Form.Control
//           type="date"
//           name="toDate"
//           required
//           autoComplete="off"
//           placeholder="Enter To Date"
//           min={fromDate}
//           value={toDate ? toDate :section?.to_date}
//           onChange={(e) => {
//             setToDate(e.target.value);
//             setIsToDateSelected(true);
//           }}
//         />
//         {errors.toDate && <p className='text-danger'>{errors.toDate.message}</p>}
//       </Form.Group>
//     </Row>

//             </div>
//             <br />
//             <br />
//         {daysOfWeek.map((day, index) => {
//           const rate = section[day] || '';
  
//           return (
//             <React.Fragment key={index}>
//               {/* <label>{day}</label> */}
//               <input
//                 id={`adultrate-${index}`}
//                 type="number"
                
//                 value={adultrate[index]  ? adultrate[index]  : rate}

//                 onChange={(e) => handleAdultRateChange(index, e.target.value)}
//                 placeholder={day.charAt(0).toUpperCase() + day.slice(1)}
//                 style={{ width: '100px', marginLeft: '15px', borderRadius: '4px', fontSize: '15px',color:'black' }}
//               />
//             </React.Fragment>
//           );
//         })}
//       </div>
//       ));
//   };
const handleHourRateChange = (index, value) => {
  const updatedHourrate = [...hourrate];
  updatedHourrate[index] = value;
  setHourrate(updatedHourrate);
};

const handleVehicleRateChange = (index, value) => {
  const updatedVehiclerate = [...vehiclerate];
  updatedVehiclerate[index] = value;
  setVehiclerate(updatedVehiclerate);
};


const renderCommissionFieldsHourly = () => {
  const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  const daysOfWeek2 = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

  if (!Array.isArray(rateshour)) {
    return null; // Return null or any other fallback JSX if rateshour is not an array
  }

  const handleCopyToAll = () => {
    const firstValue = hourrate[0]; // Get the value of the first field

    // Copy the first value to all other fields
    const updatedRates = daysOfWeek.map(() => firstValue);

    setHourrate(updatedRates); // Update the state with the new values
  };

  const handleHourRateChange = (index, value) => {
    const updatedRates = [...hourrate]; // Create a copy of the existing hourrate array
    updatedRates[index] = value; // Update the value at the specified index
    setHourrate(updatedRates); // Update the state with the new values

    // Also update the corresponding rate field
    const updatedRates2 = [...rateshour];
    updatedRates2[index] = value;
    // Optionally, update the `rateshour` variable with the new values
    // rateshour = updatedRates2;
  };

  return rateshour.map((section, sectionIndex) => (
    <div key={sectionIndex}>
            <div style={{ display: 'flex',marginTop:'30px'  }}>
        <Row className="mb-3" style={{padding:'10px'}}>
      <Form.Group as={Col} controlId="formGridServiceType">
        <Form.Label>From Date <span className='text-danger'>*</span></Form.Label>
        <Form.Control
          type="date"
          name="fromDate"
          required
           
          value={fromDate ? fromDate :section?.from_date}
          {...register('fromDate', { required: true })}
          onChange={(e) => setFromDate(e.target.value)}

          autoComplete="off"
          placeholder="Enter From Date"
    
        />
      </Form.Group>

      <Form.Group as={Col} controlId="formGridMobile">
        <Form.Label>To Date<span className='text-danger'>*</span></Form.Label>
        <Form.Control
          type="date"
          name="toDate"
          required
          autoComplete="off"
          placeholder="Enter To Date"
          min={fromDate}
          value={toDate ? toDate :section?.to_date}
          onChange={(e) => {
            setToDate(e.target.value);
            setIsToDateSelected(true);
          }}
        />
        {errors.toDate && <p className='text-danger'>{errors.toDate.message}</p>}
      </Form.Group>
    </Row>

            </div>
      <br />
      <br />
      <div  style={{display:'flex'}}>
      {daysOfWeek2.map((day, index) => {
        const rate = section[day] || '';
      

        return (
          <React.Fragment key={index}>
             <p>
          {/* <label>{day}</label> */}
          <p style={{fontSize:'15px',marginLeft:'45px',color:'black'}}>{day}</p>

            <input
              id={`hourrate-${index}`}
              type="number"
              value={hourrate[index] ? hourrate[index] : rate}
              onChange={(e) => handleHourRateChange(index, e.target.value)}
              placeholder={day.charAt(0).toUpperCase() + day.slice(1)}
              style={{ width: '100px', marginLeft: '15px', borderRadius: '4px', fontSize: '15px', color: 'black' }}
            />
            {index === 0 && (
       
       <Button variant="secondary" style={{fontSize:'10px',borderRadius:'0px', backgroundColor:'black'}} onClick={handleCopyToAll}>
       <FaArrowAltCircleRight />
       </Button>
 
      )}
      </p>
          </React.Fragment>
        );
      })}
    </div>
    </div>
  ));
};
  


const renderCommissionFieldsVehicle = () => {
  const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  const daysOfWeek2 = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

  if (!Array.isArray(ratesvehicle)) {
    return null; // Return null or any other fallback JSX if ratesvehicle is not an array
  }

  const handleCopyToAll = () => {
    const firstValue = vehiclerate[0]; // Get the value of the first field

    // Copy the first value to all other fields
    const updatedRates = daysOfWeek.map(() => firstValue);

    setVehiclerate(updatedRates); // Update the state with the new values
  };

  const handleVehicleRateChange = (index, value) => {
    const updatedRates = [...vehiclerate]; // Create a copy of the existing vehiclerate array
    updatedRates[index] = value; // Update the value at the specified index
    setVehiclerate(updatedRates); // Update the state with the new values

    // Also update the corresponding rate field
    const updatedRates2 = [...ratesvehicle];
    updatedRates2[index] = value;
    // Optionally, update the `ratesvehicle` variable with the new values
    // ratesvehicle = updatedRates2;
  };

  return ratesvehicle.map((section, sectionIndex) => (
    <div key={sectionIndex}>
            <div style={{ display: 'flex',marginTop:'30px'  }}>
        <Row className="mb-3" style={{padding:'10px'}}>
      <Form.Group as={Col} controlId="formGridServiceType">
        <Form.Label>From Date <span className='text-danger'>*</span></Form.Label>
        <Form.Control
          type="date"
          name="fromDate"
          required
           
          value={fromDate ? fromDate :section?.from_date}
          {...register('fromDate', { required: true })}
          onChange={(e) => setFromDate(e.target.value)}

          autoComplete="off"
          placeholder="Enter From Date"
    
        />
      </Form.Group>

      <Form.Group as={Col} controlId="formGridMobile">
        <Form.Label>To Date<span className='text-danger'>*</span></Form.Label>
        <Form.Control
          type="date"
          name="toDate"
          required
          autoComplete="off"
          placeholder="Enter To Date"
          min={fromDate}
          value={toDate ? toDate :section?.to_date}
          onChange={(e) => {
            setToDate(e.target.value);
            setIsToDateSelected(true);
          }}
        />
        {errors.toDate && <p className='text-danger'>{errors.toDate.message}</p>}
      </Form.Group>
    </Row>

            </div>
      <br />
      <br />
      <div  style={{display:'flex'}}>
      {daysOfWeek2.map((day, index) => {
        const rate = section[day] || '';
      

        return (
          <React.Fragment key={index}>
             <p>
          {/* <label>{day}</label> */}
          <p style={{fontSize:'15px',marginLeft:'45px',color:'black'}}>{day}</p>

            <input
              id={`vehiclerate-${index}`}
              type="number"
              value={vehiclerate[index] ? vehiclerate[index] : rate}
              onChange={(e) => handleVehicleRateChange(index, e.target.value)}
              placeholder={day.charAt(0).toUpperCase() + day.slice(1)}
              style={{ width: '100px', marginLeft: '15px', borderRadius: '4px', fontSize: '15px', color: 'black' }}
            />
            {index === 0 && (
       
       <Button variant="secondary" style={{fontSize:'10px',borderRadius:'0px', backgroundColor:'black'}} onClick={handleCopyToAll}>
       <FaArrowAltCircleRight />
       </Button>
 
      )}
      </p>
          </React.Fragment>
        );
      })}
    </div>
    </div>
  ));
};
  
const renderCommissionFieldsUpdate = () => {
  const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

  if (!Array.isArray(rates)) {
    return null; // Return null or any other fallback JSX if rates is not an array
  }

  const handleCopyToAll = () => {
    const firstValue = adultrate[0]; // Get the value of the first field

    // Copy the first value to all other fields
    const updatedRates = daysOfWeek.map(() => firstValue);

    setAdultrate(updatedRates); // Update the state with the new values
  };

  const handleAdultRateChange = (index, value) => {
    const updatedRates = [...adultrate]; // Create a copy of the existing adultrate array
    updatedRates[index] = value; // Update the value at the specified index
    setAdultrate(updatedRates); // Update the state with the new values

    // Also update the corresponding rate field
    const updatedRates2 = [...rates];
    updatedRates2[index] = value;
    // Optionally, update the `rates` variable with the new values
    // rates = updatedRates2;
  };

  return rates.map((section, sectionIndex) => (
    <div key={sectionIndex}>
            <div style={{ display: 'flex',marginTop:'30px'  }}>
        <Row className="mb-3" style={{padding:'10px'}}>
      <Form.Group as={Col} controlId="formGridServiceType">
        <Form.Label>From Date <span className='text-danger'>*</span></Form.Label>
        <Form.Control
          type="date"
          name="fromDate"
          required
           
          value={fromDate ? fromDate :section?.from_date}
          {...register('fromDate', { required: true })}
          onChange={(e) => setFromDate(e.target.value)}

          autoComplete="off"
          placeholder="Enter From Date"
    
        />
      </Form.Group>

      <Form.Group as={Col} controlId="formGridMobile">
        <Form.Label>To Date<span className='text-danger'>*</span></Form.Label>
        <Form.Control
          type="date"
          name="toDate"
          required
          autoComplete="off"
          placeholder="Enter To Date"
          min={fromDate}
          value={toDate ? toDate :section?.to_date}
          onChange={(e) => {
            setToDate(e.target.value);
            setIsToDateSelected(true);
          }}
        />
        {errors.toDate && <p className='text-danger'>{errors.toDate.message}</p>}
      </Form.Group>
    </Row>

            </div>
      <br />
      <br />
      <p style={{textAlign:'center',color:'red'}}><FaBan />&nbsp;Adults Are Not Permitted.</p>

    
    </div>
  ));
};

const renderCommissionFieldsHourlyUpdate = () => {
  const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

  if (!Array.isArray(rateshour)) {
    return null; // Return null or any other fallback JSX if rateshour is not an array
  }

  const handleCopyToAll = () => {
    const firstValue = hourrate[0]; // Get the value of the first field

    // Copy the first value to all other fields
    const updatedRates = daysOfWeek.map(() => firstValue);

    setHourrate(updatedRates); // Update the state with the new values
  };

  const handleHourRateChange = (index, value) => {
    const updatedRates = [...hourrate]; // Create a copy of the existing hourrate array
    updatedRates[index] = value; // Update the value at the specified index
    setHourrate(updatedRates); // Update the state with the new values

    // Also update the corresponding rate field
    const updatedRates2 = [...rateshour];
    updatedRates2[index] = value;
    // Optionally, update the `rateshour` variable with the new values
    // rateshour = updatedRates2;
  };

  return rateshour.map((section, sectionIndex) => (
    <div key={sectionIndex}>
            <div style={{ display: 'flex',marginTop:'30px'  }}>
        <Row className="mb-3" style={{padding:'10px'}}>
      <Form.Group as={Col} controlId="formGridServiceType">
        <Form.Label>From Date <span className='text-danger'>*</span></Form.Label>
        <Form.Control
          type="date"
          name="fromDate"
          required
           
          value={fromDate ? fromDate :section?.from_date}
          {...register('fromDate', { required: true })}
          onChange={(e) => setFromDate(e.target.value)}

          autoComplete="off"
          placeholder="Enter From Date"
    
        />
      </Form.Group>

      <Form.Group as={Col} controlId="formGridMobile">
        <Form.Label>To Date<span className='text-danger'>*</span></Form.Label>
        <Form.Control
          type="date"
          name="toDate"
          required
          autoComplete="off"
          placeholder="Enter To Date"
          min={fromDate}
          value={toDate ? toDate :section?.to_date}
          onChange={(e) => {
            setToDate(e.target.value);
            setIsToDateSelected(true);
          }}
        />
        {errors.toDate && <p className='text-danger'>{errors.toDate.message}</p>}
      </Form.Group>
    </Row>

            </div>
      <br />
      <br />
      <p style={{textAlign:'center',color:'red'}}><FaBan />&nbsp;Hours Rates Are Not Entered.</p>

    
    </div>
  ));
};

const renderCommissionFields = () => {
  const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  const daysOfWeek2 = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

  if (!Array.isArray(rates)) {
    return null; // Return null or any other fallback JSX if rates is not an array
  }

  const handleCopyToAll = () => {
    const firstValue = adultrate[0]; // Get the value of the first field

    // Copy the first value to all other fields
    const updatedRates = daysOfWeek.map(() => firstValue);

    setAdultrate(updatedRates); // Update the state with the new values
  };

  const handleAdultRateChange = (index, value) => {
    const updatedRates = [...adultrate]; // Create a copy of the existing adultrate array
    updatedRates[index] = value; // Update the value at the specified index
    setAdultrate(updatedRates); // Update the state with the new values

    // Also update the corresponding rate field
    const updatedRates2 = [...rates];
    updatedRates2[index] = value;
    // Optionally, update the `rates` variable with the new values
    // rates = updatedRates2;
  };

  return rates.map((section, sectionIndex) => (
    <div key={sectionIndex}>
            <div style={{ display: 'flex',marginTop:'30px'  }}>
        <Row className="mb-3" style={{padding:'10px'}}>
      <Form.Group as={Col} controlId="formGridServiceType">
        <Form.Label>From Date <span className='text-danger'>*</span></Form.Label>
        <Form.Control
          type="date"
          name="fromDate"
          required
           
          value={fromDate ? fromDate :section?.from_date}
          {...register('fromDate', { required: true })}
          onChange={(e) => setFromDate(e.target.value)}

          autoComplete="off"
          placeholder="Enter From Date"
    
        />
      </Form.Group>

      <Form.Group as={Col} controlId="formGridMobile">
        <Form.Label>To Date<span className='text-danger'>*</span></Form.Label>
        <Form.Control
          type="date"
          name="toDate"
          required
          autoComplete="off"
          placeholder="Enter To Date"
          min={fromDate}
          value={toDate ? toDate :section?.to_date}
          onChange={(e) => {
            setToDate(e.target.value);
            setIsToDateSelected(true);
          }}
        />
        {errors.toDate && <p className='text-danger'>{errors.toDate.message}</p>}
      </Form.Group>
    </Row>

            </div>
      <br />
      <br />
      <div  style={{display:'flex'}}>
      {daysOfWeek2.map((day, index) => {
        const rate = section[day] || '';
      

        return (
          <React.Fragment key={index}>
             <p>
          {/* <label>{day}</label> */}
          <p style={{fontSize:'15px',marginLeft:'45px',color:'black'}}>{day}</p>

            <input
              id={`adultrate-${index}`}
              type="number"
              value={adultrate[index] ? adultrate[index] : rate}
              onChange={(e) => handleAdultRateChange(index, e.target.value)}
              placeholder={day.charAt(0).toUpperCase() + day.slice(1)}
              style={{ width: '100px', marginLeft: '15px', borderRadius: '4px', fontSize: '15px', color: 'black' }}
            />
            {index === 0 && (
       
       <Button variant="secondary" style={{fontSize:'10px',borderRadius:'0px', backgroundColor:'black'}} onClick={handleCopyToAll}>
       <FaArrowAltCircleRight />
       </Button>
 
      )}
      </p>
          </React.Fragment>
        );
      })}
    </div>
    </div>
  ));
};



  const renderCommissionFields4 = () => {
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    
    const handleCopyToAll4 = () => {
      const firstValue = extraAdultrate[0]; // Get the value of the first field
    
      // Copy the first value to all other fields
      const updatedRates = daysOfWeek.map(() => firstValue);
    
      setExtraAdultrate(updatedRates); // Update the state with the new values
    };
    
    
    
    
    
    return (
      <div>
        {daysOfWeek.map((day, index) => (
          <>
          {/* <label>{day}</label> */}
          <input
            key={index}
            id={`extraAdultrate-${index}`}
            type="number"
            
            value={extraAdultrate[index] || ''}
            onChange={(e) => handleExtraAdultRateChange(index, e.target.value)}
            placeholder={day}
            style={{width:'100px',marginLeft:'15px',borderRadius:'4px',fontSize:'15px'}}
          />
            {index === 0 && (
       
           <Button variant="secondary" style={{fontSize:'10px',borderRadius:'0px', backgroundColor:'black'}} onClick={handleCopyToAll4}>
           <FaArrowAltCircleRight />
           </Button>
     
          )}
          
          </>
        ))}
       
      </div>
    );
  };
  const renderCommissionFields2 = (sectionIndex) => {
    // if (!sections || !Array.isArray(sections) || sectionIndex < 0 || sectionIndex >= sections.length) {
    //   return null;
    // }
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    
    const handleFromAgeChange = (e) => {
      setDisbutton1(false);
      const { value } = e.target;
      const isFromAgeAlreadySelected = sections.some((section, index) => {
        return index !== sectionIndex && section.fromAge === value;
      });
      if (isFromAgeAlreadySelected) {
        // Display an error message or handle the validation error as needed
        // For example, you can set an error state variable and display the error message
        setFromAgeError('From Age is already selected in another section');
      } else {
        setFromAgeError('');
        setSections((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].fromAge = value;
          return updatedSections;
        });
      }
    };
  
    const handleToAgeChange = (e) => {
      setDisbutton1(false);
      const { value } = e.target;
      const isToAgeAlreadySelected = sections.some((section, index) => {
        return index !== sectionIndex && section.toAge === value;
      });
      if (isToAgeAlreadySelected) {
        // Display an error message or handle the validation error as needed
        // For example, you can set an error state variable and display the error message
        setToAgeError('To Age is already selected in another section');
      } else {
        setToAgeError('');
        setSections((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].toAge = value;
          return updatedSections;
        });
      }
    };
 
    return (
      <div key={sectionIndex}>
      <div style={{ display: 'flex',marginLeft:'120px'  }}>
        <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>From Age</Form.Label>
        <Form.Select
          style={{ width: '268px', marginLeft: '15px' }}
          required
          value={sections[sectionIndex]?.fromAge}
          onChange={handleFromAgeChange}
          onBlur={validateForm}
        >
          <option value="">Choose..</option>
          <option value="0">0</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="10">10</option>
          <option value="11">11</option>
          <option value="12">12</option>
        </Form.Select>
        {/* {errors2.fromAge && <p className="text-danger" style={{ fontSize: '10px' }}>{errors2.fromAge}</p>} */}

        <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>To Age</Form.Label>
        <Form.Select
          style={{ width: '268px', marginLeft: '15px' }}
          required
          value={sections[sectionIndex]?.toAge}
          onChange={handleToAgeChange}
          onBlur={validateForm}
          disabled={!sections[sectionIndex]?.fromAge}
        >
          <option value="">Choose..</option>
          {[...Array(13).keys()].slice(parseInt(sections[sectionIndex]?.fromAge) + 1).map((value) => (
            <option key={value} value={value}>
              {value}
            </option>
          ))}
        </Form.Select>
        {/* &nbsp;{errors2.toAge && <p className="text-danger" style={{ fontSize: '13px' }}>{errors2.toAge}*</p>} */}
      </div>
      <br />
      <div  style={{display:'flex',marginLeft:'71px'}}>
      {daysOfWeek.map((day, index) => (
        <div key={index} style={{ display: 'inline' }}>
             <p>
            <p style={{fontSize:'15px',marginLeft:'45px',color:'black'}}>{day}</p>

          <input
            type="number"
            value={sections[sectionIndex]?.childrate[index] || ''}
            onChange={(e) => handleChildRateChange(sectionIndex, index, e.target.value)}
            placeholder={day}
            style={{ width: '100px', marginLeft: '15px', borderRadius: '4px', fontSize: '15px' }}
          />
          {index === 0 && (
            <Button variant="secondary" style={{ fontSize: '10px', borderRadius: '0px', backgroundColor:'black' }} onClick={() => handleCopyToAll2(sectionIndex, index)}>
              <FaArrowAltCircleRight />
            </Button>
          )}
          </p>
        </div>
      ))}
    </div>
    </div>
    );
  };
  



  const renderCommissionFields6 = (sectionIndex) => {
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  
    const handleFromDateChange2 = (e) => {
      setDisbutton4(false)
      const { value } = e.target;
    
      // Check if the selected from date overlaps with any existing section's date range
      const isFromDateOverlap = sections4.some((section, index) => {
        if (index !== sectionIndex && section.toDate3 && value <= section.toDate3) {
          return section.fromDate3 <= value && value <= section.toDate3;
        }
        return false;
      });
    
      if (isFromDateOverlap) {
        setFromDateError2('From Date overlaps with another section');
      } else {
        setFromDateError2('');
        setSections4((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].fromDate3 = value;
          return updatedSections;
        });
      }
      // Update promotion data
      setPromotion((prevPromotion) => {
        const updatedPromotion = [...prevPromotion];
        updatedPromotion[sectionIndex] = {
          ...updatedPromotion[sectionIndex],
          fromDate3: value,
        };
        return updatedPromotion;
      });
    };
    
    const handleToDateChange2 = (e) => {
      setDisbutton4(false)
      const { value } = e.target;
    
      // Check if the selected to date overlaps with any existing section's date range
      const isToDateOverlap = sections4.some((section, index) => {
        if (index !== sectionIndex && section.fromDate3 && value >= section.fromDate3) {
          return section.fromDate3 <= value && value <= section.toDate3;
        }
        return false;
      });
    
      if (isToDateOverlap) {
        setToDateError2('To Date overlaps with another section');
      } else {
        setToDateError2('');
        setSections4((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].toDate3 = value;
          return updatedSections;
        });
      }

        // Update promotion data
        setPromotion((prevPromotion) => {
          const updatedPromotion = [...prevPromotion];
          updatedPromotion[sectionIndex] = {
            ...updatedPromotion[sectionIndex],
            toDate3: value,
          };
          return updatedPromotion;
        });
    };

    const handlediscounttypeChange2 = (e) => {
      setDisbutton4(false)
      const { value } = e.target;
  
      setPromotion((prevPromotion) => {
        const updatedPromotion = [...prevPromotion];
        updatedPromotion[sectionIndex] = {
          ...updatedPromotion[sectionIndex],
          discounttype2: value,
        };
        return updatedPromotion;
      });
    };



    const handlediscountChange2 = (e) => {
      setDisbutton4(false)
      const { value } = e.target;
  
      setPromotion((prevPromotion) => {
        const updatedPromotion = [...prevPromotion];
        updatedPromotion[sectionIndex] = {
          ...updatedPromotion[sectionIndex],
          discount2: value,
        };
        return updatedPromotion;
      });
    };


    const handleoffercodeChange = (e) => {
      setDisbutton4(false)
      const { value } = e.target;
  
      setPromotion((prevPromotion) => {
        const updatedPromotion = [...prevPromotion];
        updatedPromotion[sectionIndex] = {
          ...updatedPromotion[sectionIndex],
          offercode: value,
        };
        return updatedPromotion;
      });
    };

    const handleremarkChange2 = (e) => {
      setDisbutton4(false)
      const { value } = e.target;
  
      setPromotion((prevPromotion) => {
        const updatedPromotion = [...prevPromotion];
        updatedPromotion[sectionIndex] = {
          ...updatedPromotion[sectionIndex],
          promotionremark: value,
        };
        return updatedPromotion;
      });
    };
    
    return (
      <div key={sectionIndex}>
        <div style={{ display: 'flex' }}>
          <Form.Label style={{ marginLeft: '63px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>
            From Date
          </Form.Label>
          <Form.Control
            type="date"
            style={{ width: '268px', marginLeft: '15px' }}
            required
            value={sections4[sectionIndex]?.fromDate3}
            onChange={handleFromDateChange2}
          />
         
  
          <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>
            To Date
          </Form.Label>
          <Form.Control
            type="date"
            style={{ width: '268px', marginLeft: '15px' }}
            required
            value={sections4[sectionIndex]?.toDate3}
            onChange={handleToDateChange2}
            disabled={!sections4[sectionIndex]?.fromDate3}
            min={sections4[sectionIndex]?.fromDate3}
          />
          {toDateError2 && <p className="text-danger" style={{ fontSize: '10px' }}>{toDateError2}</p>}
        </div>
        <br />
        {fromDateError2 && <p className="text-danger" style={{ fontSize: '12px',fontWeight:'500',textAlign:'center' }}>{fromDateError2}</p>}
        <br />
        <div style={{display:'flex'}}>
        <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>Discount</Form.Label>

        <Form.Select required name="discounttype2" value={promotion[sectionIndex]?.discounttype2 || ''} onChange={handlediscounttypeChange2}  style={{ width: '231px',height:'36px', marginLeft: '15px' }}>
                
                <option value="">Choose..</option>
                <option value="Percentage">Percentage</option>
                <option value="Fixed">Fixed</option>
              </Form.Select>


              &nbsp;
    <Form.Control  style={{ width: '231px',height:'36px' }} type="number"  name="discount2" required="true" autoComplete='off' placeholder="Enter Discount" value={promotion[sectionIndex]?.discount2  || ''} onChange={handlediscountChange2} />&nbsp;
    <Form.Control  style={{ width: '231px',height:'36px' }} type="text"  name="offercode" required="true" autoComplete='off' placeholder="Enter Offer Code" value={promotion[sectionIndex]?.offercode  || ''} onChange={handleoffercodeChange} />

&nbsp;
   
        </div>
        <br />
        <Row className="mb-3" style={{marginLeft:"0px"}}>
  <Form.Group as={Col} controlId="formGridProductdescription">
  
   <DefaultEditor rows="5" style={{backgroundColor:'white'}}   name="promotionremark" value={promotion[sectionIndex]?.promotionremark || ''} onChange={handleremarkChange2}
    />

</Form.Group>


</Row>    
        <br />
        {/* Rest of the code */}
      </div>
    );
  };




  const renderCommissionFields5 = (sectionIndex) => {
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  
    const handleFromDateChange = (e) => {
      setDisbutton3(false)
      const { value } = e.target;
  
      // Check if the selected from date overlaps with any existing section's date range
      const isFromDateOverlap = sections3.some((section, index) => {
        if (index !== sectionIndex && section.toDate2 && value <= section.toDate2) {
          return section.fromDate2 <= value && value <= section.toDate2;
        }
        return false;
      });
  
      if (isFromDateOverlap) {
        setFromDateError('From Date overlaps with another section');
      } else {
        setFromDateError('');
        setSections3((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].fromDate2 = value;
          return updatedSections;
        });
      }
  
      // Update seasonal data
      setSeasonal((prevSeasonal) => {
        const updatedSeasonal = [...prevSeasonal];
        updatedSeasonal[sectionIndex] = {
          ...updatedSeasonal[sectionIndex],
          fromDate2: value,
        };
        return updatedSeasonal;
      });
    };
  
    const handleToDateChange = (e) => {
      setDisbutton3(false)
      const { value } = e.target;
  
      // Check if the selected to date overlaps with any existing section's date range
      const isToDateOverlap = sections3.some((section, index) => {
        if (index !== sectionIndex && section.fromDate2 && value >= section.fromDate2) {
          return section.fromDate2 <= value && value <= section.toDate2;
        }
        return false;
      });
  
      if (isToDateOverlap) {
        setToDateError('To Date overlaps with another section');
      } else {
        setToDateError('');
        setSections3((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].toDate2 = value;
          return updatedSections;
        });
      }
  
      // Update seasonal data
      setSeasonal((prevSeasonal) => {
        const updatedSeasonal = [...prevSeasonal];
        updatedSeasonal[sectionIndex] = {
          ...updatedSeasonal[sectionIndex],
          toDate2: value,
        };
        return updatedSeasonal;
      });
    };
    


    const handlediscounttypeChange = (e) => {
      setDisbutton3(false)
      const { value } = e.target;
  
      setSeasonal((prevSeasonal) => {
        const updatedSeasonal = [...prevSeasonal];
        updatedSeasonal[sectionIndex] = {
          ...updatedSeasonal[sectionIndex],
          discounttype: value,
        };
        return updatedSeasonal;
      });
    };


    const handlediscountChange = (e) => {
      setDisbutton3(false)
      const { value } = e.target;
      console.log("vlaue",value)
  
      setSeasonal((prevSeasonal) => {
        const updatedSeasonal = [...prevSeasonal];
        updatedSeasonal[sectionIndex] = {
          ...updatedSeasonal[sectionIndex],
          discount: value,
        };
        return updatedSeasonal;
      });
    };


    const handleremarkChange = (e) => {
      setDisbutton3(false)
      const { value } = e.target;
  
      setSeasonal((prevSeasonal) => {
        const updatedSeasonal = [...prevSeasonal];
        updatedSeasonal[sectionIndex] = {
          ...updatedSeasonal[sectionIndex],
          seasonalremark: value,
        };
        return updatedSeasonal;
      });
    };
    
    return (
      <div key={sectionIndex}>
        <div style={{ display: 'flex' }}>
          <Form.Label style={{ marginLeft: '63px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>
            From Date
          </Form.Label>
          <Form.Control
            type="date"
            style={{ width: '268px', marginLeft: '15px' }}
            required
            value={sections3[sectionIndex]?.fromDate2}
            onChange={handleFromDateChange}
          />
  
          <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>
            To Date
          </Form.Label>
          <Form.Control
            type="date"
            style={{ width: '268px', marginLeft: '15px' }}
            required
            value={sections3[sectionIndex]?.toDate2}
            onChange={handleToDateChange}
            disabled={!sections3[sectionIndex]?.fromDate2}
            min={sections3[sectionIndex]?.fromDate2}
          />
          {toDateError && <p className="text-danger" style={{ fontSize: '10px' }}>{toDateError}</p>}
        </div>
        <br />
        {fromDateError && <p className="text-danger" style={{ fontSize: '12px',fontWeight:'500',textAlign:'center' }}>{fromDateError}</p>}

        <br />
        <div style={{display:'flex',marginLeft:'22px'}}>
        <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>Seasonal Rate</Form.Label>

        <Form.Select required name="discounttype" value={seasonal[sectionIndex]?.discounttype || '' } onChange={handlediscounttypeChange}  style={{ width: '270px',height:'36px', marginLeft: '15px' }}>
                
                <option value="">Choose..</option>
                <option value="Percentage">Percentage</option>
                <option value="Fixed">Fixed</option>
              </Form.Select>


              {/* &nbsp;        <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>Discount</Form.Label> */}

    <Form.Control name="discount"  style={{ width: '270px',height:'36px', marginLeft: '73px'  }} type="number" value={seasonal[sectionIndex]?.discount || ''} onChange={handlediscountChange}    required="true" autoComplete='off' placeholder="Enter AddOn Rate"  />

&nbsp;
    
        </div>
        <br />
     
        <Row className="mb-3" style={{marginLeft:'0px'}}>
  <Form.Group as={Col} controlId="formGridProductdescription">
  {/* <Form.Label>Description</Form.Label> */}
  
   <DefaultEditor rows="5"  name="seasonalremark"  style={{backgroundColor:'white'}} value={seasonal[sectionIndex]?.seasonalremark || ''} onChange={handleremarkChange}  
    />

</Form.Group>


</Row>        <br />
       
      </div>
    );
  };
  
  
  




  const renderCommissionFields3 = (sectionIndex) => {
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    
    const handleFromAgeChange = (e) => {
      setDisbutton2(false)
      const { value } = e.target;
      const isFromAgeAlreadySelected = sections2.some((section, index) => {
        return index !== sectionIndex && section.fromAge2 === value;
      });
      if (isFromAgeAlreadySelected) {
        // Display an error message or handle the validation error as needed
        // For example, you can set an error state variable and display the error message
        setFromAgeError2('From Age is already selected in another section');
      } else {
        setFromAgeError2('');
        setSections2((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].fromAge2 = value;
          return updatedSections;
        });
      }
    };
  
    const handleToAgeChange = (e) => {
      setDisbutton2(false)
      const { value } = e.target;
      const isToAgeAlreadySelected = sections2.some((section, index) => {
        return index !== sectionIndex && section.toAge2 === value;
      });
      if (isToAgeAlreadySelected) {
        // Display an error message or handle the validation error as needed
        // For example, you can set an error state variable and display the error message
        setToAgeError2('To Age is already selected in another section');
      } else {
        setToAgeError2('');
        setSections2((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].toAge2 = value;
          return updatedSections;
        });
      }
    };
 
    return (
      <div key={sectionIndex}>
      <div style={{ display: 'flex',marginLeft:'120px'  }}>
        <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>From Age</Form.Label>
        <Form.Select
          style={{ width: '268px', marginLeft: '15px' }}
          required
          value={sections2[sectionIndex]?.fromAge2}
          onChange={handleFromAgeChange}
          onBlur={validateForm2}
        >
          <option value="">Choose..</option>
          <option value="0">0</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
        
        </Form.Select>
        {/* {errors2.fromAge && <p className="text-danger" style={{ fontSize: '10px' }}>{errors2.fromAge}</p>} */}

        <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>To Age</Form.Label>
        <Form.Select
          style={{ width: '268px', marginLeft: '15px' }}
          required
          value={sections2[sectionIndex]?.toAge2}
          onChange={handleToAgeChange}
          onBlur={validateForm2}
          disabled={!sections2[sectionIndex]?.fromAge2}
        >
          <option value="">Choose..</option>
          {[...Array(7).keys()].slice(parseInt(sections2[sectionIndex]?.fromAge2) + 1).map((value) => (
            <option key={value} value={value}>
              {value}
            </option>
          ))}
        </Form.Select>
        {/* &nbsp;{errors2.toAge && <p className="text-danger" style={{ fontSize: '13px' }}>{errors2.toAge}*</p>} */}
      </div>
      <br />
      <div  style={{display:'flex',marginLeft:'71px'}}>
      {daysOfWeek.map((day, index) => (
        <div key={index} style={{ display: 'inline' }}>
           <p>
            <p style={{fontSize:'15px',marginLeft:'45px',color:'black'}}>{day}</p>

          <input
            type="number"
            value={sections2[sectionIndex]?.infantrate[index] || ''}
            onChange={(e) => handleInfantRateChange(sectionIndex, index, e.target.value)}
            placeholder={day}
            style={{ width: '100px', marginLeft: '15px', borderRadius: '4px', fontSize: '15px' }}
          />
          {index === 0 && (
            <Button variant="secondary" style={{ fontSize: '10px', borderRadius: '0px', backgroundColor:'black' }} onClick={() => handleCopyToAll3(sectionIndex, index)}>
              <FaArrowAltCircleRight />
            </Button>
          )}
          </p>
        </div>
      ))}
    </div>
    </div>
    );
  };

  

  const validateToDate = (toDate) => {
    if (!fromDate) {
      return 'Please select a From Date first';
    }
  
    const fromDateObj = new Date(fromDate);
    const toDateObj = new Date(toDate);
  
    if (toDateObj < fromDateObj) {
      return 'To Date must be later than or equal to From Date';
    }
  
    return true; // Return true if the validation passes
  };

  const validateToDate2 = (stoDate) => {
    if (!sfromDate) {
      return 'Please select a From Date first';
    }
  
    const fromDateObj = new Date(sfromDate);
    const toDateObj = new Date(stoDate);
  
    if (toDateObj < fromDateObj) {
      return 'To Date must be later than or equal to From Date';
    }
  
    return true; // Return true if the validation passes
  };

  const validateForm = () => {
    const newErrors = {};

    if (fromAge === '') {
      newErrors.fromAge = 'From Age is required';
    }

    if (toAge === '') {
      newErrors.toAge = 'To Age is required';
    } else if (parseInt(toAge) <= parseInt(fromAge)) {
      newErrors.toAge = 'To Age must be greater than From Age';
    }

    setErrors2(newErrors);
  };

  const validateForm2 = () => {
    const newErrors = {};

    if (fromAge2 === '') {
      newErrors.fromAge2 = 'From Age is required';
    }

    if (toAge2 === '') {
      newErrors.toAge2 = 'To Age is required';
    } else if (parseInt(toAge2) <= parseInt(fromAge2)) {
      newErrors.toAge2 = 'To Age must be greater than From Age';
    }

    setErrors3(newErrors);
  };


  

  const handleFromAgeChange2 = (e) => {
    setFromAge2(e.target.value);
    setToAge2('');
  };
  
const handlePaxlimit = (e) =>{
  const checked = e.target.checked;

  
  if(e.target.name == "paxlimit" && checked){
    setPaxlimit(1);
    setPaxlimitShow(true)
  }else {
    setPaxlimit(0)
    setPaxlimitShow(false);
  }
}
  const handleCommission = (e) =>{

    if(e == "Percentage"){
      setPerShow(true);
      setFixamtShow(false)
    }else if(e == "Fixamt"){
      setFixamtShow(true)
      setPerShow(false);
    }
    }
  
  useEffect(() => {
    dispatch(getAllProduct());
    dispatch(getSingleProductRate(baseId));
    dispatch(getSinglePaxhealth(pid2));
    dispatch(getAllMainSubProduct());
    const filterperm = subproducts2.filter(obj => obj.id == pid1)
    setPermdata(filterperm[0]);
    console.log("filterperm[0]",filterperm[0])
 
    
  }, [dmessage,mmessage,imessage,smessage,pmessage,hpmessage, vpmessage]);

  
  useEffect(() => {
    const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  
    if (Array.isArray(rates) && rates.length > 0) {
      const initialRates = daysOfWeek.map((day) => (rates[0][day] || '').toString());
      console.log('initialRates:', initialRates);
      setAdultrate(initialRates);
      setAdultratecopy(initialRates);
      setFromDate(rates?.[0]?.from_date)
      setToDate(rates?.[0]?.to_date)
    }
  }, [rates]);


  useEffect(() => {
    const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  
    if (Array.isArray(rateshour) && rateshour.length > 0) {
      const initialRates = daysOfWeek.map((day) => (rateshour[0][day] || '').toString());
      console.log('initialRates:', initialRates);
      setHourrate(initialRates);
      setHourratecopy(initialRates);
      setFromDate(rateshour?.[0]?.from_date)
      setToDate(rateshour?.[0]?.to_date)
    }
  }, [rateshour]);



  useEffect(() => {
    const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  
    if (Array.isArray(ratesvehicle) && ratesvehicle.length > 0) {
      const initialRates = daysOfWeek.map((day) => (ratesvehicle[0][day] || '').toString());
      setVehiclerate(initialRates);
      setVehicleratecopy(initialRates);
      setFromDate(ratesvehicle?.[0]?.from_date)
      setToDate(ratesvehicle?.[0]?.to_date)
    }
  }, [ratesvehicle]);
  
  
  

  const handleOnSubmit = (e) => {
    e.preventDefault();
    if(productid && subproductname && status){
        const newSubProductCreation1 = {
            productid,
            subproductname,
            paxlimit,
            paxlimitno,
            status,

        };
        dispatch(
            newSubProductCreation(newSubProductCreation1)
        )
        Swal.fire({
            title: 'Success!',
            text: 'Sub Product Details Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          })
  
          // navigate('/subproductList');
         
            setTabHandle2('rate')
        
        setProductid('');
        setSubproductname('');
        setPaxlimitNo('');
        setStatus('');
        e.target.reset();
    }
 
  };


  const handleOnSubmit1 = (e) => {
    e.preventDefault();
    dispatch(getSingleProductRate(baseId));

    if (fromDate !== rates?.[0]?.from_date || toDate !== rates?.[0]?.to_date || adultrate !== adultratecopy) {
      const newAdultRateModification = {
        baseId,
        fromDate,
        toDate,
        adultrate,

      };
      dispatch(
        adultrateModification(newAdultRateModification)
      )
      Swal.fire({
        title: 'Success!',
        text: 'Adult Rate Updated Successfully',
        icon: 'success',
        confirmButtonText: 'Okay'
      })

    } else {
      Swal.fire('No changes made!', '', 'warning');

    }
 

        
 
 
  };



  const handleOnSubmithour = (e) => {
    e.preventDefault();
    dispatch(getSingleProductRate(baseId));

    if (fromDate !== rates?.[0]?.from_date || toDate !== rates?.[0]?.to_date || hourrate !== hourratecopy) {
      const newHourRateModification = {
        baseId,
        fromDate,
        toDate,
        hourrate,

      };
      dispatch(
        hourrateModification(newHourRateModification)
      )
      Swal.fire({
        title: 'Success!',
        text: 'Hour Rate Updated Successfully',
        icon: 'success',
        confirmButtonText: 'Okay'
      })

    } else {
      Swal.fire('No changes made!', '', 'warning');

    }
 

        
 
 
  };



  const handleOnSubmitvehicle = (e) => {
    e.preventDefault();
    dispatch(getSingleProductRate(baseId));

    if (fromDate !== rates?.[0]?.from_date || toDate !== rates?.[0]?.to_date || vehiclerate !== vehicleratecopy) {
      const newVehicleModification = {
        baseId,
        fromDate,
        toDate,
        vehiclerate,

      };
      dispatch(
        vehiclerateModification(newVehicleModification)
      )
      Swal.fire({
        title: 'Success!',
        text: 'Vehicle Rate Updated Successfully',
        icon: 'success',
        confirmButtonText: 'Okay'
      })

    } else {
      Swal.fire('No changes made!', '', 'warning');

    }
 

        
 
 
  };


  
  // const handleOnSubmit2 = (e) => {
  //   e.preventDefault();
  //   // console.log("rates2?.from_age",rates2?.from_age)
  //   // console.log("fromAge",fromAge)
  //   // console.log("toAge",toAge)
    

  //   if (fromAge !== '' || toAge !== '') {
  //     const newChildRateModification = {
  //       baseId,
  //       fromDate,
  //       toDate,
  //       fromAge,
  //       toAge,
  //       childRates: childrate,

  //     };
  //     dispatch(
  //       childrateModification(newChildRateModification)
  //     )
  //     Swal.fire({
  //       title: 'Success!',
  //       text: 'Child Rate Updated Successfully',
  //       icon: 'success',
  //       confirmButtonText: 'Okay'
  //     })


  //   } else {

  //     Swal.fire('No changes made!', '', 'warning');

  //   }

      
 
  // };

  const handleOnSubmit2 = (e) => {
    e.preventDefault();
    const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    dispatch(getSingleProductRate(baseId));
    const updatedSections2 = rates2.map((section) => ({
      id: section.id,
      fromAge: section.from_age,
      toAge: section.to_age,
      childrate: daysOfWeek.map((day) => (section[day] || '').toString()),
    }));
    // setChildratecopy(updatedSections2);
   
  
    if (JSON.stringify(childrate) === JSON.stringify(updatedSections2)) {
      Swal.fire('No changes made!', '', 'warning');
      return;
    }else{
     
      const newChildRateModification = {
        baseId,
        fromDate,
        toDate,
        fromAge,
        toAge,
        childRates: childrate,
      };
    
      dispatch(childrateModification(newChildRateModification));
      dispatch(getSingleProductRate(baseId));
      // setChildratecopy(childrate);

      setDisbutton1(true)
      setResetRates2(true);

    
     
    
     
      if (childrate.some(obj => !obj.hasOwnProperty('id'))) {
        // Perform the navigation to the specific path here
        navigate('/viewratespage/' + pid1+ "/" +pname1 + "/" + pid2 + "/" + pname2);
        
      }
      setChildrate([]);
      Swal.fire({
        title: 'Success!',
        text: 'Child Rate Updated Successfully',
        icon: 'success',
        confirmButtonText: 'Okay'
      });


     
   



    }
    
  
    
  };
  console.log("data1",childrate)
  console.log("data2",childratecopy)
  console.log("data3",rates2)
  


    
  const handleOnSubmit3 = (e) => {
    const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

    e.preventDefault();
    dispatch(getSingleProductRate(baseId));

    const updatedSections = rates3.map((section) => ({
      id: section.id,
      fromAge2: section.from_age,
      toAge2: section.to_age,
      infantrate: daysOfWeek.map((day) => (section[day] || '').toString()),
    }));
    if (JSON.stringify(infantrate) === JSON.stringify(updatedSections)) {
      Swal.fire('No changes made!', '', 'warning');
      return;
    }else{
      const newInfantRateModify = {
        baseId,
        fromDate,
        toDate,
        fromAge2,
        toAge2,
        infantRates: infantrate,

    };
    dispatch(
      infantrateModification(newInfantRateModify)
    )
    dispatch(getSingleProductRate(baseId));

    setDisbutton2(true);
    if (infantrate.some(obj => !obj.hasOwnProperty('id'))) {
      // Perform the navigation to the specific path here
      navigate('/viewratespage/' + pid1+ "/" +pname1 + "/" + pid2 + "/" + pname2);
      
    }
    setInfantrate([]);
    Swal.fire({
        title: 'Success!',
        text: 'Infant Rate Updated Successfully',
        icon: 'success',
        confirmButtonText: 'Okay'
      })


    }

      
 
  };

  const handleOnSubmit4 = (e) => {
    e.preventDefault();
    dispatch(getSingleProductRate(baseId));
    const updatedSections33 = rates4.map((section) => ({
      id: section.id,
      fromDate2: section.start_date,
      toDate2: section.end_date,
      discounttype: section.discount_type,
      discount: section.discount,
      seasonalremark: section.remarks,
    }));
    if (JSON.stringify(seasonal) === JSON.stringify(updatedSections33)) {
      Swal.fire('No changes made!', '', 'warning');
      return;
    }else{
      const newSeasonalRateModify = {
        baseId,
       
        seasonalRates: seasonal,

    };
    dispatch(
      seasonalrateModification(newSeasonalRateModify)
    )
    setDisbutton3(true)
    dispatch(getSingleProductRate(baseId));
    Swal.fire({
        title: 'Success!',
        text: 'Seasonal Rate Updated Successfully',
        icon: 'success',
        confirmButtonText: 'Okay'
      })

    }

        
 
 
  };


  const handleOnSubmit5 = (e) => {
    e.preventDefault();

    dispatch(getSingleProductRate(baseId));


    const updatedSections33 = rates5.map((section) => ({
      id: section.id,
      fromDate3: section.start_date,
      toDate3: section.end_date,
      discounttype2: section.discount_type,
      discount2: section.discount,
      offercode: section.offer_code,
      promotionremark: section.remarks,
    }));
    if (JSON.stringify(promotion) === JSON.stringify(updatedSections33)) {
      Swal.fire('No changes made!', '', 'warning');
      return;
    } else {

      const newPromotionRateModify = {
        baseId,

        promotionRates: promotion,

      };
      dispatch(
        promotionrateModification(newPromotionRateModify)
      )
      dispatch(getSingleProductRate(baseId));
      setDisbutton4(true)
      Swal.fire({
        title: 'Success!',
        text: 'Promotion Rate Updated Successfully',
        icon: 'success',
        confirmButtonText: 'Okay'
      })



    }


  };
  const onBack = () => {
   
    //console.log('select role '+id);
    navigate('/viewratespage/' + pid1+ "/" +pname1 + "/" + pid2 + "/" + pname2); 
 }

  const canSave = Boolean (productid) && Boolean(subproductname) && Boolean(status)
//console.log(curstatus);
//console.log('msg');
//console.log(curmessage);
  //console.log(passwordError.confirmPassword);
  
  return (
    <>
        <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-80px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"  style={{fontFamily:'Times New Roman', fontWeight:'600' }}>Modify Rates</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                            <div><span className="badge bg-success" onClick={onBack} style={{backgroundColor:'rgb(156 186 237)',color:'white',cursor:'pointer'}}><FaArrowLeft />&nbsp;Go Back</span></div>
   
                        </Row>
                        <br />
                <Tabs
      // defaultActiveKey='basic'
      activeKey={tabHandle2}
      id="justify-tab-example"
      className="mb-3"
      justify
    >
     

           
    <Tab eventKey="rate" title="Rate Details">
      
    
    {/* <span className="badge bg-success" onClick={onBack} style={{backgroundColor:'rgb(156 186 237)',color:'white',cursor:'pointer'}}><FaArrowLeft />&nbsp;Go Back</span>  <center><span className="badge bg" style={{backgroundColor:'rgb(156 186 237)',color:'black'}}>From Date: {rates[0]?.from_date} --- To Date: {rates[0]?.to_date}</span></center> */}

      
      <hr />
      
    <Tabs
      defaultActiveKey='adultrate'
    //   activeKey={tabHandle}
      id="justify-tab-example"
      className="mb-3"
      justify
      
    >
         {permdata?.isithourly == 1 ?  
                         <Tab eventKey="adultrate" title="Hourly Rates">
    
                        <><Form   className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmithour(e))}> {/* handleOnSubmit() */}
                         <Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
                   
             
                 <h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Hourly Rates</h6>
                   
                   <hr style={{marginTop:'5px',color:'white'}} />
                  
             
                   {renderCommissionFieldsHourly()}
                 <br />
                   <div><Button variant="" type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Update </Button></div>
             
                  <br />
                  {/* <div><Button variant="" type='submit'  onClick={()=>setTabHandle('seasonalrate')} style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div> */}
                  <br />
             
                 </Card>
                
             
                       </Form></>
                         
                 </Tab>
             
             
                    
                    :''}


{permdata?.isitvehicle == 1 ?  
                         <Tab eventKey="adultrate" title="Vehicle Rates">
    
                        <><Form   className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmitvehicle(e))}> {/* handleOnSubmit() */}
                         <Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
                   
             
                 <h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Vehicle Rates</h6>
                   
                   <hr style={{marginTop:'5px',color:'white'}} />
                  
             
                   {renderCommissionFieldsVehicle()}
                 <br />
                   <div><Button variant="" type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Update </Button></div>
             
                  <br />
                  {/* <div><Button variant="" type='submit'  onClick={()=>setTabHandle('seasonalrate')} style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div> */}
                  <br />
             
                 </Card>
                
             
                       </Form></>
                         
                 </Tab>
             
             
                    
                    :''}
                    {permdata?.isithourly !== 1 && permdata?.isitvehicle !== 1 ?  
            <Tab eventKey="adultrate" title="Adult Rates">
    
            {permdata?.adult_per == 1 || pxData?.adult_permission == 0 ? <>     <Form   className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit1(e))}> {/* handleOnSubmit() */}
            <Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
      

    <h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Adult Rates</h6>
      
      <hr style={{marginTop:'5px',color:'white'}} />
     

      {renderCommissionFieldsUpdate()}
    <br />
      <div><Button variant="" type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Update </Button></div>

     <br />
     <br />

    </Card>
   

          </Form></>:<><Form   className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit1(e))}> {/* handleOnSubmit() */}
            <Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
      

    <h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Adult Rates</h6>
      
      <hr style={{marginTop:'5px',color:'white'}} />
     

      {renderCommissionFields()}
    <br />
      <div><Button variant="" type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Update </Button></div>

     <br />
     {/* <div><Button variant="" type='submit'  onClick={()=>setTabHandle('childrate')} style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div> */}
     <br />

    </Card>
   

          </Form></>}
            
    </Tab>:''}
    {permdata?.isithourly !== 1 && permdata?.isitvehicle !== 1 ?

    <Tab eventKey="childrate" title="Child Rates">
  {permdata?.child_per == 1 || pxData?.child_permission == 0 ? (
    <>
    <Card  style={{backgroundColor:''}}>
              <br />
              <p style={{textAlign:'center',color:'red'}}><FaBan />&nbsp;Childs Are Not Permitted.</p>
              
              
            <br />
     {/* <div><Button variant=""  onClick={()=>setTabHandle('infantrate')} style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div> */}
     <br />
              </Card>

    </>
  ) : (
    <>
      <Form className="mx-4 my-2" component="form" noValidate autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit2(e))}>
        <Card style={{ backgroundColor: '#1c355ea3',width:'100%' }}>
          <h6 style={{ textAlign: 'center', marginTop: '10px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>Child Rates</h6>

          <div>
            <Button variant="" style={{ width: '100px', float: 'right', backgroundColor: '#1c355e', color: 'white', marginRight: '5px', fontSize: '10px' }} onClick={handleAddSection}>
              <FaPlus />&nbsp;Add
            </Button>
          </div>
          {sections.map((section, index) => (
            <div key={index}>
              <hr style={{ marginTop: '15px', color: 'white',height:'5px',opacity:'0.9' }} />
<br />              {renderCommissionFields2(index)}
              <Button variant="" style={{ fontSize: '15px', float: 'right', color: 'red' }} onClick={() => handleRemoveSection(index,section.id)}>
                <FaTrash />
              </Button>
              <br />
            </div>
          ))}

          <br />
          <hr style={{ marginTop: '5px', color: 'white' }} />

          <br />

        
          <div><Button variant="" type='submit' disabled={disbutton1} style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Update </Button></div>
          <br />
        </Card>
      </Form>    </>
  )}
</Tab> :'' }

{permdata?.isithourly !== 1 && permdata?.isitvehicle !== 1 ?
<Tab eventKey="infantrate" title="Infant Rates">
    
{permdata?.infant_per == 1 || pxData?.infant_permission == 0 ? <> <Card  style={{backgroundColor:''}}>
              <br />
              <p style={{textAlign:'center',color:'red'}}><FaBan />&nbsp;Infants Are Not Permitted.</p>
              
              
            <br />
     {/* <div><Button variant=""  onClick={()=>setTabHandle('seasonalrate')} style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div> */}
     <br />
              </Card></>:<> <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit3(e))}> {/* handleOnSubmit() */}

<Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
<h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Infant Rates</h6>
<div><Button variant="" style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}} onClick={handleAddSection2}><FaPlus/>&nbsp;Add </Button></div>



 


    <div >
            {sections2.map((section, index) => (
              <>
        <div key={index}>
                <hr style={{marginTop:'15px',color:'white',height:'5px',opacity:'0.9'}} />
 <br />
          {renderCommissionFields3(index)}
          <Button variant="" style={{fontSize:'15px',float:'right',color:'red'}}   onClick={() => handleRemoveSection2(index,section.id)}><FaTrash  /></Button>
          <br />

        </div>
        </>
      ))}    </div>

  <br />
  <hr style={{marginTop:'5px',color:'white'}} />
  <br />

        
<div><Button variant="" disabled={disbutton2} type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Update </Button></div>
<br />

  
 
 {/* <div><Button variant="" type='submit' onClick={()=>setTabHandle('seasonalrate')} style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div> */}
 <br />
</Card>
</Form></>}
  



</Tab>
: ''}
<Tab eventKey="seasonalrate" title="Seasonal Supplementary">
    
<Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit4(e))}> {/* handleOnSubmit() */}

<Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
<h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Seasonal Supplementary</h6>
<div><Button variant="" style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}} onClick={handleAddSection3}><FaPlus/>&nbsp;Add </Button></div>



 

{sections3.map((section, index) => (
    <div key={index}>
                <hr style={{marginTop:'15px',color:'white',height:'5px',opacity:'0.9'}} />

      {/* Render your section-specific fields here */}
      {renderCommissionFields5(index)}
      <Button variant="" style={{fontSize:'15px',float:'right',color:'red'}}   onClick={() => handleRemoveSection3(index,section.id)}><FaTrash  /></Button>
    </div>
  ))}
  <br />
  <hr style={{marginTop:'5px',color:'white'}} />
  
  <br />
      {/* <div><Button variant="" type='submit'  style={{width:'100px' ,float:'right',backgroundColor:'#d1af2b',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Save </Button></div> */}


 <br />
 
 <div><Button variant="" disabled={disbutton3} type='submit'  style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Update </Button></div>
 <br />
</Card>
</Form>
</Tab>


<Tab eventKey="promotionalrate" title="Promotion Discount">
    

<Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit5(e))}> {/* handleOnSubmit() */}

<Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
<h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Promotion Discount</h6>
<div><Button variant="" style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}} onClick={handleAddSection4}><FaPlus/>&nbsp;Add </Button></div>



 

{sections4.map((section, index) => (
    <div key={index}>
                <hr style={{marginTop:'15px',color:'white',height:'5px',opacity:'0.9'}} />

      {/* Render your section-specific fields here */}
      {renderCommissionFields6(index)}
      <Button variant="" style={{fontSize:'15px',float:'right',color:'red'}}   onClick={() => handleRemoveSection4(index,section.id)}><FaTrash  /></Button>
    </div>
  ))}
  <br />
  <hr style={{marginTop:'5px',color:'white'}} />
  

  <br />
      {/* <div><Button variant="" type='submit'  style={{width:'100px' ,float:'right',backgroundColor:'#d1af2b',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Save </Button></div> */}

 <br />
 
 <div><Button variant="" disabled={disbutton4} type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Update </Button></div>
 <br />
</Card>
</Form>
</Tab>
           
   

    </Tabs>

    

</Tab>


    </Tabs>
          </div>
        </div>
      </div>
    </>
  );
}

export default ModifyRates;